// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daily-releases-admin {
  width: min(96vw, 900px);
  max-height: 86vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.daily-releases-admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.daily-releases-admin__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.daily-releases-admin__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.daily-releases-admin__close .icon { width: 1.1rem; height: 1.1rem; }

.daily-releases-admin__close:hover {
  background: #23384f;
  color: #fff;
}

.daily-releases-admin__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.daily-releases-admin__hint {
  margin: 0 0 0.9rem;
  color: #9fb4cc;
  font-size: 0.9rem;
}

.daily-releases-admin__nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.daily-releases-admin__day {
  min-width: 16rem;
  text-align: center;
  color: #fff;
  font-weight: 600;
}

.daily-releases-admin__arrow {
  background: #23384f;
  border: 1px solid rgba(74, 158, 255, 0.35);
  color: #cdd8e6;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1;
  transition: background 0.2s, color 0.2s, opacity 0.2s;
}

.daily-releases-admin__arrow:hover:not(:disabled) {
  background: #2f4c6b;
  color: #fff;
}

.daily-releases-admin__arrow:disabled {
  opacity: 0.4;
  cursor: default;
}

.daily-releases-admin__error {
  padding: 0.7rem 0.9rem;
  border-radius: 8px;
  background: rgba(225, 87, 89, 0.15);
  border: 1px solid rgba(225, 87, 89, 0.4);
  color: #ffb3b4;
  margin-bottom: 0.9rem;
}

.daily-releases-admin__status {
  padding: 1.4rem 0;
  text-align: center;
  color: #9fb4cc;
}

.daily-releases-admin__chart-viewport {
  position: relative;
  overflow: hidden;
  height: 360px;
}

/* Centered overlay for loading / empty states, drawn on top of the reserved chart area so the
   viewport keeps a constant footprint regardless of the current day's data. */
.daily-releases-admin__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #9fb4cc;
  background: rgba(20, 32, 48, 0.55);
  pointer-events: none;
}

.daily-releases-admin__chart-slide {
  height: 100%;
}

.daily-releases-admin__canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}

/* Horizontal slide-in when navigating days. The class is applied on load; the animation plays
   once and leaves the chart settled at its resting position. */
.daily-releases-admin__chart-slide--next {
  animation: daily-releases-slide-next 0.32s ease;
}

.daily-releases-admin__chart-slide--prev {
  animation: daily-releases-slide-prev 0.32s ease;
}

@keyframes daily-releases-slide-next {
  from { transform: translateX(28%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@keyframes daily-releases-slide-prev {
  from { transform: translateX(-28%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .daily-releases-admin__chart-slide--next,
  .daily-releases-admin__chart-slide--prev {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/daily-releases-admin-panel/daily-releases-admin-panel.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,qCAAqC,aAAa,EAAE,cAAc,EAAE;;AAEpE;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;8EAC8E;AAC9E;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;+DAC+D;AAC/D;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,OAAO,0BAA0B,EAAE,UAAU,EAAE;EAC/C,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".daily-releases-admin {\r\n  width: min(96vw, 900px);\r\n  max-height: 86vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.daily-releases-admin__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.daily-releases-admin__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.daily-releases-admin__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.daily-releases-admin__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.daily-releases-admin__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.daily-releases-admin__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.daily-releases-admin__hint {\r\n  margin: 0 0 0.9rem;\r\n  color: #9fb4cc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.daily-releases-admin__nav {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.daily-releases-admin__day {\r\n  min-width: 16rem;\r\n  text-align: center;\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n.daily-releases-admin__arrow {\r\n  background: #23384f;\r\n  border: 1px solid rgba(74, 158, 255, 0.35);\r\n  color: #cdd8e6;\r\n  width: 2.2rem;\r\n  height: 2.2rem;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  line-height: 1;\r\n  transition: background 0.2s, color 0.2s, opacity 0.2s;\r\n}\r\n\r\n.daily-releases-admin__arrow:hover:not(:disabled) {\r\n  background: #2f4c6b;\r\n  color: #fff;\r\n}\r\n\r\n.daily-releases-admin__arrow:disabled {\r\n  opacity: 0.4;\r\n  cursor: default;\r\n}\r\n\r\n.daily-releases-admin__error {\r\n  padding: 0.7rem 0.9rem;\r\n  border-radius: 8px;\r\n  background: rgba(225, 87, 89, 0.15);\r\n  border: 1px solid rgba(225, 87, 89, 0.4);\r\n  color: #ffb3b4;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.daily-releases-admin__status {\r\n  padding: 1.4rem 0;\r\n  text-align: center;\r\n  color: #9fb4cc;\r\n}\r\n\r\n.daily-releases-admin__chart-viewport {\r\n  position: relative;\r\n  overflow: hidden;\r\n  height: 360px;\r\n}\r\n\r\n/* Centered overlay for loading / empty states, drawn on top of the reserved chart area so the\r\n   viewport keeps a constant footprint regardless of the current day's data. */\r\n.daily-releases-admin__overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  color: #9fb4cc;\r\n  background: rgba(20, 32, 48, 0.55);\r\n  pointer-events: none;\r\n}\r\n\r\n.daily-releases-admin__chart-slide {\r\n  height: 100%;\r\n}\r\n\r\n.daily-releases-admin__canvas {\r\n  display: block;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n/* Horizontal slide-in when navigating days. The class is applied on load; the animation plays\r\n   once and leaves the chart settled at its resting position. */\r\n.daily-releases-admin__chart-slide--next {\r\n  animation: daily-releases-slide-next 0.32s ease;\r\n}\r\n\r\n.daily-releases-admin__chart-slide--prev {\r\n  animation: daily-releases-slide-prev 0.32s ease;\r\n}\r\n\r\n@keyframes daily-releases-slide-next {\r\n  from { transform: translateX(28%); opacity: 0; }\r\n  to { transform: translateX(0); opacity: 1; }\r\n}\r\n\r\n@keyframes daily-releases-slide-prev {\r\n  from { transform: translateX(-28%); opacity: 0; }\r\n  to { transform: translateX(0); opacity: 1; }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .daily-releases-admin__chart-slide--next,\r\n  .daily-releases-admin__chart-slide--prev {\r\n    animation: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
